// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bah1y6m{justify-content:flex-start}
._1bahesu3{justify-content:flex-end}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1n261g80{flex-wrap:wrap}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/tag-group/dist/esm/TagGroup/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,0BAA0B;AACrC,WAAW,wBAAwB;AACnC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,cAAc","sourcesContent":["._1bah1y6m{justify-content:flex-start}\n._1bahesu3{justify-content:flex-end}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1n261g80{flex-wrap:wrap}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
